/**
* @ngdoc directive
* @name Check Number
*
* @element input
*
* @description
  Attribute used to validate check number in input
*
* @example
  <div ng-init='check="789"'>
  <input
    check-number
    name="checkNumber"
    placeholder="Check #"
    ng-model="check"
    />
  </div>
*/

(function () {
  directive.$inject = ["$timeout"];
  app.directive('checkNumber', directive);

  function directive($timeout) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: link
    };

    function link($scope, element, attr, ngModel) {
      var MAX_CHECK_NUMBER = 999999;

      init();

      function init() {
        element.addClass('form-control');
        attr.$set('type', 'number');
        attr.$set('data-toggle', 'tooltip');
        attr.$set('data-original-title', 'Entry error');
        ngModel.$validators.decimals = function (modelValue, viewValue) {
          var isInvalidValue = isInvalid(viewValue);
          setError(isInvalidValue);
          return !isInvalidValue;
        };
      }

      /*
        Validators
      */

      function isInvalid(viewValue) {
        if (!viewValue) {
          return attr.required && !attr.disabled;
        }

        return viewValue > MAX_CHECK_NUMBER || !/^\d+$/.test(viewValue);
      }

      function setError(shouldShowError) {
        if (shouldShowError) element.tooltip({ trigger: 'manual' }).tooltip('show');
        else element.tooltip('destroy');
      }

      element.on('focus', function () {
        $timeout(function () {
          try {
            element.get(0).setSelectionRange(0, 100);
          } catch (e) {
            try {
              element.get(0).select();
            } catch (e2) {}
          }
        }, 20);
      });
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/checkNumber.js